import PageLayout from '../components/PageLayout'
import Seo from '../components/Seo'

export default function Terms() {
  return (
    <PageLayout title="Kullanım Koşulları">
      <Seo title="Kullanım Koşulları" />
      <div className="space-y-8 text-gray-300">
        <section>
          <h2 className="mb-3 text-xl font-semibold text-white">1. Genel Hükümler</h2>
          <p>Bu web sitesini (saatbahane.com) ziyaret ederek, aşağıda belirtilen kullanım koşullarını kabul etmiş sayılırsınız. Saatbahane, bu koşulları dilediği zaman değiştirme hakkını saklı tutar.</p>
        </section>
        <section>
          <h2 className="mb-3 text-xl font-semibold text-white">2. Ürün ve Hizmetler</h2>
          <p>Web sitemizde sergilenen ürünler &quot;katalog&quot; mahiyetindedir. Fiyatlar ve stok durumu değişkenlik gösterebilir. Kesin bilgi için WhatsApp hattımız üzerinden teyit alınması gerekmektedir.</p>
        </section>
        <section>
          <h2 className="mb-3 text-xl font-semibold text-white">3. Fikri Mülkiyet</h2>
          <p>Sitede yer alan görseller, logolar ve metinler Saatbahane&apos;nin mülkiyetindedir veya lisanslı olarak kullanılmaktadır. İzinsiz kopyalanamaz.</p>
        </section>
      </div>
    </PageLayout>
  )
}

